//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ShowMyFormsWidget: FeatureFlag = {"Id":"ShowMyFormsWidget","Label":"Show MyForms Widget","Impact":"Show the widget for MyForms","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
